<section class="checkout">
  <header class="checkout__header">

    <ol class="checkout__steps" aria-label="Checkout steps">
      <li
        class="checkout__step is-complete"
        tabindex="0"
        role="button"
        (click)="onStepperClick('amount')"
        (keydown.enter)="onStepperClick('amount')"
        (keydown.space)="onStepperClick('amount')"
        [attr.aria-label]="'CAMPAIGN.Checkout.Amount' | translate">
        <span class="checkout__step-index" aria-hidden="true">
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="checkout__step-label">{{ 'CAMPAIGN.Checkout.Amount' | translate }}</span>
      </li>
      <li
        class="checkout__step"
        tabindex="0"
        role="button"
        [class.is-active]="currentView === 'details'"
        [class.is-complete]="currentView === 'summary' || currentView === 'payment'"
        (click)="onStepperClick('details')"
        (keydown.enter)="onStepperClick('details')"
        (keydown.space)="onStepperClick('details')"
        [attr.aria-label]="'CAMPAIGN.Checkout.Details' | translate">
        <span class="checkout__step-index" aria-hidden="true">
          <ng-container *ngIf="currentView === 'summary' || currentView === 'payment'; else detailsNum">
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ng-container>
          <ng-template #detailsNum>2</ng-template>
        </span>
        <span class="checkout__step-label">{{ 'CAMPAIGN.Checkout.Details' | translate }}</span>
      </li>
      <li
        class="checkout__step"
        tabindex="0"
        role="button"
        [class.is-active]="currentView === 'summary'"
        [class.is-complete]="currentView === 'payment'"
        (click)="onStepperClick('summary')"
        (keydown.enter)="onStepperClick('summary')"
        (keydown.space)="onStepperClick('summary')"
        [attr.aria-label]="'CAMPAIGN.Checkout.Summary' | translate">
        <span class="checkout__step-index" aria-hidden="true">
          <ng-container *ngIf="currentView === 'payment'; else summaryNum">
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ng-container>
          <ng-template #summaryNum>3</ng-template>
        </span>
        <span class="checkout__step-label">{{ 'CAMPAIGN.Checkout.Summary' | translate }}</span>
      </li>
      <li
        class="checkout__step"
        tabindex="0"
        role="button"
        [class.is-active]="currentView === 'payment'"
        (click)="onStepperClick('payment')"
        (keydown.enter)="onStepperClick('payment')"
        (keydown.space)="onStepperClick('payment')"
        [attr.aria-label]="'CAMPAIGN.Checkout.Payment' | translate">
        <span class="checkout__step-index" aria-hidden="true">4</span>
        <span class="checkout__step-label">{{ 'CAMPAIGN.Checkout.Payment' | translate }}</span>
      </li>
    </ol>
  </header>

  <main class="checkout__layout">
    <aside class="checkout__summary" aria-label="Donation summary">
      <ng-container [ngTemplateOutlet]="summaryPanel"></ng-container>
    </aside>

    <section class="checkout__main" aria-live="polite">
      <article class="checkout__panel" [class.is-hidden]="currentView !== 'details'" [attr.aria-hidden]="currentView !== 'details'">
        <div class="checkout__panel-header">
          <h2 class="checkout__panel-title">
            <img src="assets/Image/icons-donate/_donor-info.svg" alt="" aria-hidden="true">
            {{ 'CAMPAIGN.DonorInformation' | translate }}
          </h2>
        </div>

        <div class="checkout__summary-mobile" *ngIf="currentView === 'details'">
          <ng-container [ngTemplateOutlet]="summaryPanel"></ng-container>
        </div>

        <don-donor-form
          [formValue]="donorFormValue$ | async"
          [showBackButton]="true"
          [backButtonLabel]="'CAMPAIGN.Checkout.Back' | translate"
          (backClicked)="goBack()"
          (formSubmitted)="onDonorFormSubmitted($event)">
        </don-donor-form>
      </article>

      <!-- ── STEP 3: Donation summary review ─────────────────────────── -->
      <article class="checkout__panel" [class.is-hidden]="currentView !== 'summary'" [attr.aria-hidden]="currentView !== 'summary'">
        <div class="checkout__panel-header">
          <h2 #summaryHeading tabindex="-1" class="checkout__panel-title">
            <img src="assets/Image/icons-donate/_verified-shield.svg" alt="" aria-hidden="true">
            {{ 'CAMPAIGN.Checkout.YourDonationSummary' | translate }}
          </h2>
        </div>

        <div class="checkout__summary-mobile" *ngIf="currentView === 'summary'">
          <ng-container [ngTemplateOutlet]="summaryPanel"></ng-container>
        </div>

        <don-checkout-summary
          *ngIf="summaryVm$ | async as vm"
          [vm]="vm"
          titleKey="CAMPAIGN.Checkout.YourDonationSummary"
          (vmChange)="onSummaryVmChange($event)">
        </don-checkout-summary>

        <div class="checkout__summary-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="backToDetails()">
            <span aria-hidden="true">←</span> {{ 'CAMPAIGN.Checkout.BackToInfo' | translate }}
          </button>
          <button type="button" class="btn btn-primary" (click)="goToPayment()">
            {{ 'CAMPAIGN.Checkout.ContinueToPayment' | translate }} <span aria-hidden="true">→</span>
          </button>
        </div>
      </article>

      <!-- ── STEP 4: Secure payment (includes donation summary) ────────── -->
      <article class="checkout__panel" [class.is-hidden]="currentView !== 'payment'" [attr.aria-hidden]="currentView !== 'payment'">
        <div class="checkout__panel-header">
          <h2 #paymentHeading tabindex="-1" class="checkout__panel-title">
            {{ 'CAMPAIGN.Checkout.SecurePayment' | translate }}
          </h2>
        </div>

        <div class="checkout__summary-mobile" *ngIf="currentView === 'payment'">
          <ng-container [ngTemplateOutlet]="summaryPanel"></ng-container>
        </div>

        <p class="checkout__security-note">{{ 'CAMPAIGN.Checkout.SecurityMessage' | translate }}</p>

        <ng-container *ngIf="currentView === 'payment' && (active$ | async) as active">
          <don-payment-element-view
            [containerId]="containerId"
            [isReady]="isReady$ | async"
            [isConfirming]="isConfirming$ | async"
            [active]="(active$ | async) ?? false"
            [confirmLabel]="(confirmLabel$ | async) ?? (confirmLabelKey | translate)"
            [showBackButton]="true"
            [backLabel]="'CAMPAIGN.Checkout.BackToSummary' | translate"
            (viewEntered)="onViewEntered($event)"
            (viewExited)="onViewExited()"
            (backClicked)="backToSummary()"
            (confirmClicked)="onConfirmClicked()">
          </don-payment-element-view>
        </ng-container>
          

        <div class="checkout__card-brands">
          <span class="checkout__card-brands-label">{{ 'CAMPAIGN.Checkout.AcceptedCards' | translate }}</span>
          <span class="checkout__card-brand checkout__card-brand--visa" aria-label="Visa">VISA</span>
          <span class="checkout__card-brand checkout__card-brand--mastercard" aria-label="Mastercard">
            <i></i><i></i>
          </span>
          <span class="checkout__card-brand checkout__card-brand--amex" aria-label="American Express">AMEX</span>
        </div>
      </article>
    </section>

  </main>

  <ng-template #summaryPanel>
    <section class="summary-panel">

      <div class="summary-panel__lang">
        <don-language-selector size="desktop" class="summary-panel__lang-desktop" (languageChange)="changeLanguage($event)">
        </don-language-selector>
        <don-language-selector size="mobile" class="summary-panel__lang-mobile" (languageChange)="changeLanguage($event)">
        </don-language-selector>
      </div>

      <ng-container *ngIf="currentView !== 'payment'">
        <div class="summary-panel__campaign" *ngIf="selectedCampaign$ | async as campaign">
          <img class="summary-panel__image" [src]="campaign.imageUrl || 'assets/Image/Story/banner.webp'" [alt]="campaign.nameEn || campaign.nameEs || 'Campaign image'" (error)="onCampaignImageError($event)">
          <div class="summary-panel__campaign-text">
            <p class="summary-panel__campaign-name">
              {{ getLocalizedCampaignName(campaign) }}
            </p>
            <p class="summary-panel__campaign-description">
              {{ selectedLanguage.value === 'es' ? campaign.descriptionEs : campaign.descriptionEn }}
            </p>
          </div>
        </div>
      </ng-container>

      <!-- ── Payment step: compact campaign header + cost breakdown + security note ── -->
      <ng-container *ngIf="currentView === 'payment'">
        <div class="summary-panel__campaign-compact" *ngIf="selectedCampaign$ | async as campaign">
          <p class="summary-panel__campaign-name">
            {{ getLocalizedCampaignName(campaign) }}
          </p>
          <img src="assets/Image/icons-donate/_verified-shield.svg" alt="" aria-hidden="true">
        </div>

        <div class="summary-panel__cost-breakdown" *ngIf="summaryVm$ | async as vm">
          <div class="summary-panel__cost-row">
            <span>{{ 'CAMPAIGN.DonationAmount' | translate }}</span>
            <strong>{{ vm.donationAmount | currency:(vm.currency | uppercase):'symbol':'1.2-2' }} {{ vm.currency | uppercase }}</strong>
          </div>

          <div class="summary-panel__cost-row">
            <span>{{ (vm.hasCalculatedFees ? 'CAMPAIGN.Checkout.FeeCalculated' : 'CAMPAIGN.TransactionFee') | translate }}</span>
            <strong *ngIf="vm.hasCalculatedFees; else feePendingValue">
              {{ (vm.donationFees || 0) | currency:(vm.currency | uppercase):'symbol':'1.2-2' }} {{ vm.currency | uppercase }}
            </strong>
            <ng-template #feePendingValue><span>--</span></ng-template>
          </div>

          <div class="summary-panel__divider"></div>

          <div class="summary-panel__cost-row summary-panel__cost-row--total">
            <span>{{ 'CAMPAIGN.Checkout.Total' | translate }}</span>
            <strong>
              {{ (vm.hasCalculatedFees && vm.feesCovered ? vm.donationAmount + (vm.donationFees || 0) : vm.donationAmount) | currency:(vm.currency | uppercase):'symbol':'1.2-2' }} {{ vm.currency | uppercase }}
            </strong>
          </div>
        </div>

        <div class="summary-panel__security-note">
          <img src="assets/Image/icons-donate/modal/icon-lock-gray.svg" alt="" aria-hidden="true">
          <div>
            <p class="summary-panel__security-title">{{ 'CAMPAIGN.Checkout.DonationIsSecure' | translate }}</p>
            <p class="summary-panel__security-text">{{ 'CAMPAIGN.Checkout.DonationIsSecureDescription' | translate }}</p>
          </div>
        </div>
      </ng-container>

      <div class="summary-panel__checks" *ngIf="currentView === 'details' && displayNameControl && isCompanyControl">
        <label class="form-check">
          <input class="form-check-input" type="checkbox" [formControl]="displayNameControl" />
          <span class="form-check-label">{{ 'CAMPAIGN.DisplayName' | translate }}</span>
        </label>

        <label class="form-check">
          <input class="form-check-input" type="checkbox" [formControl]="isCompanyControl" />
          <span class="form-check-label">{{ 'CAMPAIGN.CompanyContribution' | translate }}</span>
        </label>
      </div>
    </section>
  </ng-template>

  <div *ngIf="isLoading$ | async" class="loader-container">
    <app-loader></app-loader>
  </div>

  <don-fee-review-modal
    *ngIf="feeReview$ | async as vm"
    [visible]="vm.visible"
    [summaryVm]="summaryVm$ | async"
    (summaryVmChange)="onSummaryVmChange($event)"
    (accept)="onFeeAccept()"
    (useAnotherCard)="onUseAnotherCard()"
    (cancel)="onFeeCancel()">
  </don-fee-review-modal>
</section>
